import { ArrowRightLeftIcon } from 'lucide-react'

import { SwapAction } from './types'
import { ActionRow } from '@/features/actions/components/action-row/ActionRow'
import { ActionRowBaseProps } from '@/features/actions/components/action-row/types'

export interface SwapActionRowProps extends ActionRowBaseProps {
  action: SwapAction
}

export function SwapActionRow({ action: { from, to, amount }, ...props }: SwapActionRowProps) {
  return (
    <ActionRow {...props}>
      <ActionRow.Icon icon={ArrowRightLeftIcon} />

      <ActionRow.Title>
        <ActionRow.Title.Tokens tokens={[from, to]} />
        Swap {from.symbol} for {to.symbol}
      </ActionRow.Title>

      <ActionRow.Amount token={from} amount={amount} />

      <ActionRow.ErrorWarning />

      <ActionRow.Trigger>Swap</ActionRow.Trigger>
    </ActionRow>
  )
}
